
import { useEffect } from 'react'


const QRMessages = ({ data, isActiveWomensMode }) => {

    const LoadPage = async () => {
        try {
            document.getElementById("root").classList.add("BodyComplete")
        } catch (error) {
            
        }
    }

    useEffect(() => {
        LoadPage()
    }, [])
    

    return (
        <>
            <div className='SelfieFan__Screen__QR__Background'>
                {isActiveWomensMode ? (
                    <img src='/img/selfiefan/Fondo-SelfieFan-Femenil.png' className='SelfieFan__Screen__Selfie__Background__Image' />
                ) : isActiveWomensMode === false && (
                    <img src='/img/selfiefan/Fondo-SelfieFan-Varonil-s2-1.png' className='SelfieFan__Screen__Selfie__Background__Image' />
                )}
            </div>

            <div className='SelfieFan__Screen__QR__Box SelfieFan__Screen__QR__Up'>
                <div className='SelfieFan__Screen__QR__Container'>
                    <div className='SelfieFan__Screen__QR__Container__Instructions'>
                        <img src="/img/page/adsl-five.png" className="Screen__Welcome__Container__Info__Image" alt="Logo" />
                        <p className='SelfieFan__Screen__QR__Container__Instructions__Text' style={{ fontFamily: '"GFS Didot", serif' }}>ESCANEA EL CÓDIGO Y ENVÍA TU MENSAJE A LA PANTALLA</p>
                    </div>
                    
                    <img src='/img/page/qr/messages-qr-fondo-gris-sin-parametros.png' className='SelfieFan__Screen__QR__Container__QR' />
                </div>
            </div>

            <footer className='SelfieFan__Screen__QR__Footer FooterCredits'>Hecho con ♥ por Interaktia | 2026</footer>
        </>
    )
}

export { QRMessages };










// import { useEffect, useState } from 'react'


// const QRMessages = ({ data, isActiveWomensMode }) => {

//     // --- ESTADOS PARA EL EFECTO DE ESCRITURA ---
//     const [text, setText] = useState('');
//     const [isDeleting, setIsDeleting] = useState(false);
//     const [loopNum, setLoopNum] = useState(0);
//     const [typingSpeed, setTypingSpeed] = useState(150);

//     // Las frases que se van a rotar
//     const phrases = [
//         "TU MEDIA NARANJA",
//         "ESA PERSONA ESPECIAL",
//         "TU CRUSH"
//     ];

//     const LoadPage = async () => {
//         try {
//             document.getElementById("root").classList.add("BodyComplete")
//         } catch (error) {
            
//         }
//     }

//     // Efecto de carga inicial (Tu código original)
//     useEffect(() => {
//         LoadPage()
//     }, [])

//     // --- LÓGICA MÁQUINA DE ESCRIBIR ---
//     useEffect(() => {
//         const handleTyping = () => {
//             const i = loopNum % phrases.length;
//             const fullText = phrases[i];

//             setText(isDeleting 
//                 ? fullText.substring(0, text.length - 1) 
//                 : fullText.substring(0, text.length + 1)
//             );

//             // Velocidad base
//             let speed = 150;

//             if (isDeleting) {
//                 speed /= 2; // Borra más rápido
//             }

//             if (!isDeleting && text === fullText) {
//                 // Terminó de escribir la frase completa: Espera un momento
//                 speed = 2000; 
//                 setIsDeleting(true);
//             } else if (isDeleting && text === '') {
//                 // Terminó de borrar: Pasa a la siguiente frase
//                 setIsDeleting(false);
//                 setLoopNum(loopNum + 1);
//                 speed = 500;
//             }

//             setTypingSpeed(speed);
//         };

//         const timer = setTimeout(handleTyping, typingSpeed);

//         return () => clearTimeout(timer);
//     }, [text, isDeleting, loopNum, typingSpeed, phrases]);
    

//     return (
//         <>
//             {/* Estilo local para el cursor parpadeante */}
//             <style>
//                 {`
//                     .blinking-cursor {
//                         font-weight: 100;
//                         font-size: 1.2em;
//                         color: white;
//                         animation: blink 1s step-end infinite;
//                     }
//                     @keyframes blink {
//                         0%, 100% { opacity: 1; }
//                         50% { opacity: 0; }
//                     }
//                 `}
//             </style>

//             <div className='SelfieFan__Screen__QR__Background'>
//                 {/* {isActiveWomensMode ? (
//                     <img src='/img/selfiefan/Fondo-SelfieFan-Femenil.png' className='SelfieFan__Screen__Selfie__Background__Image' />
//                 ) : isActiveWomensMode === false && (
//                     <img src='/img/selfiefan/Fondo-SelfieFan-Varonil-s2-1.png' className='SelfieFan__Screen__Selfie__Background__Image' />
//                 )} */}
//                 <img src='/img/page/backgrounds/valentines-day-2026/heart-balloons-background.png' className='SelfieFan__Screen__Selfie__Background__Image' alt="" />
//             </div>

//             <div className='QRMessages__Screen__Title'>
//                 <p className='QRMessages__Screen__Title__Text Fonts--DynaPuff'>
//                     ENVÍA UN MENSAJE A <span>{text}</span><span className="blinking-cursor">|</span>
//                 </p>
//             </div>

//             <div className='QRMessages__Screen__QR'>
//                 <img src='/img/page/qr/messages-qr-fondo-rosa-claro-sin-parametros.png' className='SelfieFan__Screen__QR__Container__QR' alt="QR" />
//             </div>

//             <footer className='SelfieFan__Screen__QR__Footer FooterCredits QRMessages__Screen__Footer Fonts--DynaPuff'>Hecho con ♥ por Interaktia | 2026</footer>
//         </>
//     )
// }

// export { QRMessages };









// import { useEffect } from 'react'


// const QRMessages = ({ data, isActiveWomensMode }) => {

//     const LoadPage = async () => {
//         try {
//             document.getElementById("root").classList.add("BodyComplete")
//         } catch (error) {
            
//         }
//     }

//     useEffect(() => {
//         LoadPage()
//     }, [])
    

//     return (
//         <>
//             <div className='SelfieFan__Screen__QR__Background'>
//                 {/* {isActiveWomensMode ? (
//                     <img src='/img/selfiefan/Fondo-SelfieFan-Femenil.png' className='SelfieFan__Screen__Selfie__Background__Image' />
//                 ) : isActiveWomensMode === false && (
//                     <img src='/img/selfiefan/Fondo-SelfieFan-Varonil-s2-1.png' className='SelfieFan__Screen__Selfie__Background__Image' />
//                 )} */}
//                 <img src='/img/page/backgrounds/valentines-day-2026/heart-balloons-background.png' className='SelfieFan__Screen__Selfie__Background__Image' />
//             </div>

//             <div className='QRMessages__Screen__Title'>
//                 <p className='QRMessages__Screen__Title__Text Fonts--DynaPuff'>ENVÍA UN MENSAJE A TU MEDIA NARANJA</p>
//             </div>

//             <div className='QRMessages__Screen__QR'>
//                 <img src='/img/page/qr/messages-qr-fondo-rosa-claro-sin-parametros.png' className='SelfieFan__Screen__QR__Container__QR' />
//             </div>

//             <footer className='SelfieFan__Screen__QR__Footer FooterCredits QRMessages__Screen__Footer'>Hecho con ♥ por Interaktia | 2026</footer>
//         </>
//     )
// }

// export { QRMessages };